import React, { useEffect } from "react";
import { getCommunityTransactions } from "../../../../actions/appExpandedActions/communities";
import { connect } from "react-redux";
import DataTable from "../../DataTable/DataTable";

const TransactionsCommunities = ({ getCommunityTransactions, communityTransactions, period, loading }) => {
  useEffect(() => {
    getCommunityTransactions({ page: 1, limit: 20 });
  }, []);

  // Handle period changes - support new PeriodSelector format
  useEffect(() => {
    const payload = { page: 1, limit: 20 };
    
    // For "All time" or no dates, send empty strings
    if (period?.type === "all" || (!period?.startDate && !period?.endDate)) {
      payload.startDate = "";
      payload.endDate = "";
    } else if (period?.startDate && period?.endDate) {
      // For specific periods, send the actual dates
      payload.startDate = period.startDate;
      payload.endDate = period.endDate;
    }
    
    getCommunityTransactions(payload);
  }, [period]);

  const handleLoadMore = (page) => {
    const payload = { page, limit: 20 };
    
    if (period?.type === "all" || (!period?.startDate && !period?.endDate)) {
      payload.startDate = "";
      payload.endDate = "";
    } else if (period?.startDate && period?.endDate) {
      payload.startDate = period.startDate;
      payload.endDate = period.endDate;
    }
    
    getCommunityTransactions(payload);
  };

  return (
    <DataTable
      preset="transactionsCommunities"
      data={{
        docs: communityTransactions?.docs || [],
        totalPages: communityTransactions?.totalPages || 0
      }}
      onLoadMore={handleLoadMore}
      loading={loading}
    />
  );
};

const mapStateToProps = (state) => ({
  communityTransactions: state.appCommunities.communityTransactions,
  loading: state.appCommunities.loading,
});

const mapDispatchToProps = (dispatch) => ({
  getCommunityTransactions: (payload) => dispatch(getCommunityTransactions(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TransactionsCommunities);
